
export const SLIDER_ITEMS = [
  {
    src: '/assets/images/home_sliders/school_live_db.png',
    altText: 'School Data',
    caption: 'School Live Dashboard',
    viewpage: 'schoolviz'

  },
  {
    src: '/assets/images/home_sliders/documentation_page.png',
    altText: 'Methodology',
    caption: 'Documentation',
    viewpage: 'documentation'
  },
  {
    src: '/assets/images/home_sliders/state_visuals.png',
    altText: 'State Level',
    caption: 'State Level Visuals',
    viewpage: 'stateviz'
  }
];
